export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/78489dd5fe22b2b724f99f5861a7cee7.svg";